/**
 * Logout View
 */

define(function(require, exports, module) {
    'use strict';

    const LogoutReplacer = require('replacers/logout/logout.view');
    const user = require('user');
    const core = require('core');

    module.exports = LogoutReplacer.extend({

        subscribe: function() {
            this.listenTo(core, 'change:login', this.render);
        },

        render: function() {
            const isLoggedIn = user.isLoggedIn();
            this.$el.html(this.tmpl('logout', {isLoggedIn}));

            return this;
        },

        logout: function() {
            LogoutReplacer.prototype.logout.apply(this, arguments);
            this.render();
        }

    }, {
        nameOfReplacers: [
            'LOGOUT'
        ]
    });
});